import React from "react";
import { EvtHeader } from "components/header";
import { useFetch } from "@/hooks/useFetch";
import { useParams } from "react-router-dom";
import { fetchSurveysAverage } from "../api";
import CommonCard from "components-v2/kpi/common-card";
import { HOME_CARD_CONTENT } from "@/modules/home/constants";

export default function SurveyCardSection({ onClick }) {

    const { jobId } = useParams();

    const { data: averages, isLoading } = useFetch({
        queryKey: ["surveys-average", jobId],
        queryFn: () => fetchSurveysAverage({ jobId }),
        enabled: !!jobId,
    });
    console.log("averages", averages)

    const categoriesMap = {};

    if (Array.isArray(averages)) {
        averages.forEach((survey) => {
            survey.questions?.forEach((qResp) => {
                const categoryName = qResp.question?.category?.name;
                const responseValue = Number(qResp.response);

                if (categoryName) {
                    if (!categoriesMap[categoryName]) {
                        categoriesMap[categoryName] = { total: 0, count: 0 };
                    }
                    categoriesMap[categoryName].total += responseValue;
                    categoriesMap[categoryName].count += 1;
                }
            });
        });
    }

    const processedCategories = Object.entries(categoriesMap).map(([categoryName, { total, count }]) => ({
        categoryName,
        average: Math.round((total / count) * 10),
        total,
        count,
    }));

    if(!processedCategories.length) return null;

    return (
        <div className="w-full flex-1">
            <div>
                <EvtHeader title={`Survey Insights`} />
                <div className="flex flex-wrap gap-4 px-4 lg:px-6 ">
                    {processedCategories.map((category) => {
                        const cardContent = Object.values(HOME_CARD_CONTENT).find(
                            (item) =>
                                item.title?.toLowerCase() === category.categoryName?.toLowerCase() 
                        );
                        const description = cardContent?.description || "";

                        const cardData = {
                            title: category.categoryName,
                            description: description,
                            value: category.average,
                            unit: "%",
                            details: [
                                { label: "Average Rating", value: (category.total / category.count).toFixed(2) },
                                { label: "Responses Count", value: category.count },
                            ],
                        };

                        return (
                            <CommonCard
                                key={category.categoryName}
                                title={category.categoryName}
                                info={description}
                                percentage={category.average}
                                isLoading={isLoading}
                                onClick={onClick}
                                cardData={cardData}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
